import React, { useEffect, useRef, useState } from 'react';
import { KTSVG } from '../../../_metronic/helpers';
import AddEnterpriseForm from './AddEnterpriseForm';
import Swal from 'sweetalert2';
import { addEnterpriseData } from '../../../api';
import countries from '../../../utils/constants';

interface EnterpriseResponse {
    email: string;
    name: string;
    site: string;
    country: string;
    ph: string;
    unit: string;
    id: number;
    apikey: string;
    password: string;

    // Contract details (add these fields to the response interface)
    contract_start_date: string      // ← add
    contract_end_date: string        // ← add
    contract_duration_months: number // ← add
    contract_status: string        // ← add
}

function EnterpriseModal({ isOpen, onClose }) {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        site: '',
        ph: '',
        country: '',
        // unit: '',

        // Contract details
        // contract_start_date: '',
        // contract_duration_months: '',
    });

    const [submittedForm, setSubmittedForm] = useState(false)
    const [password, setPassword] = useState({
        password: ''
    })
    const [enterpriseResponse, setEnterpriseResponse] = useState<EnterpriseResponse>()

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (name, selectedOption) => {
        setFormData((prev) => ({ ...prev, [name]: selectedOption }));
    };

    const validateForm = () => {
        if (!formData.name) {
            return 'Enterprise Name is required.';
        }
        if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
            return 'Valid Enterprise Email is required.';
        }
        const selectedCountry = countries.find(country => country.name === formData.country);
        if (!selectedCountry) return 'Please select a valid country.';

        if (
            !formData.ph ||
            !/^\d+$/.test(formData.ph) ||
            formData.ph.length !== (selectedCountry?.phoneNumberLength || 0)
        ) {

            return `Phone number must be a valid ${selectedCountry?.phoneNumberLength}-digit number for ${selectedCountry?.name}.`;

        }

        // // Contract details validation
        // if (!formData.contract_start_date) {
        //     return 'Contract Start Date is required.'
        // }
        // if (!formData.contract_duration_months || Number(formData.contract_duration_months) < 1) {
        //     return 'Contract Duration must be at least 1 month.'
        // }


        // if (!formData.unit) {
        //     return 'Enterprise unit selection is required.';
        // }
        return null;
    };

    const handleSubmit = async () => {
        const errorMessage = validateForm();
        if (errorMessage) {
            Swal.fire({
                icon: 'error',
                title: errorMessage,
            });
            return;
        }

        try {
            const response = await addEnterpriseData(formData);
            setEnterpriseResponse(response);
            setPassword(response.password);
            if (response) {
                Swal.fire({
                    icon: 'success',
                    title: `Account is created for ${formData.name}.`,
                }).then(() => {
                    setSubmittedForm(true);
                });
                setSubmittedForm(true);
            }
            //   else {
            //     Swal.fire({
            //       icon: 'error',
            //       title: 'API Error',
            //       text: response.data.message || 'Something went wrong with the submission.',
            //     });
            //   }
        } catch (error: any) {
            console.error('Error enterprise user:', error.response.data.detail);
            Swal.fire({
                title: error.response.data.detail,
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    useEffect(() => {
        if (!submittedForm) {
        }
    }, [submittedForm]);




    const handleReset = () => {
        setFormData({
            name: '',
            email: '',
            site: '',
            ph: '',
            country: ''
        });
        onClose();
        setSubmittedForm(false);
        setEnterpriseResponse(undefined);
    }

    const downloadCSV = () => {
        if (!enterpriseResponse) {
            console.error('Enterprise response data is not available');
            return;
        }

        const data = [
            ["Enterprise ID", "Enterprise Name", "Email", "Site", "Country", "Phone No.", "Password", "Contract Start Date", "Contract End Date",
                "Contract Duration Months"],
            [
                enterpriseResponse.id,
                enterpriseResponse.name,
                enterpriseResponse.email,
                enterpriseResponse.site,
                enterpriseResponse.country,
                enterpriseResponse.ph,
                // enterpriseResponse.unit, 
                enterpriseResponse.password,
                // enterpriseResponse.contract_start_date,       // ← add
                // enterpriseResponse.contract_end_date,         // ← add
                // enterpriseResponse.contract_duration_months,  // ← add
            ]
        ];

        const csvContent = data.map(e => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute("download", "enterprise_response.csv");
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <div
            className={`modal fade ${isOpen ? 'show' : ''}`}
            tabIndex={-1}
            id="kt_modal_1"
            style={{ display: isOpen ? 'block' : 'none' }}
        >
            <div className="modal-dialog" style={{ marginTop: '9rem' }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">
                            {submittedForm ? 'Account Created Successfully' : 'Create New Enterprise Account'}
                        </h3>
                        <div
                            className="btn btn-icon btn-sm btn-active-secondary ms-2"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={handleReset}
                        >
                            <KTSVG
                                path="media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                            />
                        </div>
                    </div>
                    <div className="modal-body" style={{ height: '35vh', overflow: 'auto' }} >
                        <AddEnterpriseForm
                            formData={formData}
                            onInputChange={handleInputChange}
                            onSelectChange={handleSelectChange}
                            submittedForm={submittedForm}
                            enterpriseResponse={enterpriseResponse}
                        />
                    </div>
                    <div className="modal-footer">
                        {submittedForm ?
                            <div className='d-flex justify-content-between w-100'>
                                <button
                                    type="button"
                                    className="btn"
                                    style={{ backgroundColor: '#6D9300', color: 'white' }}
                                    onClick={downloadCSV}
                                >
                                    Download CSV
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                    onClick={handleReset}
                                >
                                    Close
                                </button>
                            </div>
                            :
                            <button
                                type="button"
                                className="btn"
                                style={{ backgroundColor: '#6D9300', color: 'white' }}
                                onClick={handleSubmit}
                            >
                                Create Enterprise
                            </button>}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnterpriseModal;